import '~/stylesheets/react-components/cta-nudge.scss';
import Cookies from 'js-cookie';
import cx from 'classnames';
import springIcon from '~/images/icons/spring-icon.png';
import { useEffect, useState } from 'react';

const CtaNudge = ({ contentfulContent }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const { header, content, button_text: buttonText } = contentfulContent;
  const cookieName = content.replace(/ /g, '_');
  const path = window.location.pathname;
  const millisecondsUntilDisplayed = window.railsEnv === 'test' ? 1000 : 10000;
  const pathsToNotShowNudgeOn = ['/donate/the-spring', '/the-spring/direct'];

  const enableNudge = () => {
    setIsEnabled(true);
  };

  window.enableNudge = enableNudge;

  const shouldShowNudge = () => {
    const cookie = Cookies.get(cookieName);
    const isProhibitedPath = pathsToNotShowNudgeOn.includes(path);
    return isEnabled && !isProhibitedPath && !(cookie === 'true');
  };

  useEffect(() => {
    if (shouldShowNudge()) {
      const timer = setTimeout(() => {
        setIsHidden(false);
        Cookies.set(cookieName, true, { expires: 365 });
        window.track_event('Viewed Nudge', {
          cta_header: header,
          cta_content: content,
          cta_button_text: buttonText,
          page_path: path,
        });
      }, millisecondsUntilDisplayed);

      return () => clearTimeout(timer);
    }
  }, [isEnabled]);

  const handleCTAClick = () => {
    window.track_event('Clicked Nudge CTA', {
      cta_header: header,
      cta_content: content,
      cta_button_text: buttonText,
      page_path: path,
    });
  };

  if (!shouldShowNudge()) {
    return <></>;
  }

  return (
    <div
      className={cx(
        'theme-design-system-v1 relative pl-10 pr-6 py-3 border-solid border border-grey-40 rounded shadow-sm lg-block lg-max-w-xs bg-cw-white hidden',
        {
          'lg-hidden': isHidden,
        }
      )}
    >
      <img
        alt='spring-icon'
        className='absolute spring-icon'
        src={springIcon}
      />
      <button
        className='bg-cw-white border-none cursor absolute top-0 right-0 px-3 -mb-1 rounded'
        onClick={() => setIsHidden(true)}
      >
        x
      </button>
      <h1 className='h50 py-nudge'>{header}</h1>
      <p className='mb-1'>{content}</p>
      <a
        className='button button--small bg-cw-spring-med-green text-cw-white mb-nudge'
        href='/donate/the-spring'
        onClick={handleCTAClick}
      >
        {buttonText}
      </a>
    </div>
  );
};

export default CtaNudge;
